import { gql } from '@apollo/client';

/**
 * Tenants and the umbrella organizations above them, as platform staff
 * provision them. Reads need `tenants` Read on the platform; every write here
 * needs `tenants` Full.
 */

export interface OrganizationRef {
  id: string;
  name: string | null;
}

export interface TenantRecord {
  id: string;
  name: string | null;
  slug: string | null;
  extAppApiId: string | null;
  createdAt: string | null;
  organization: OrganizationRef | null;
}

export interface OrganizationTenant {
  id: string;
  name: string | null;
  slug: string | null;
  extAppApiId: string | null;
}

export interface OrganizationRecord {
  id: string;
  name: string | null;
  slug: string | null;
  extAppApiId: string | null;
  createdAt: string | null;
  tenants: OrganizationTenant[];
}

const TENANT_FIELDS = `
  id
  name
  slug
  extAppApiId
  createdAt
  organization { id name }
`;

const ORGANIZATION_FIELDS = `
  id
  name
  slug
  extAppApiId
  createdAt
  tenants { id name slug extAppApiId }
`;

export const TENANTS_QUERY = gql`
  query Tenants {
    brokerages {
      ${TENANT_FIELDS}
    }
  }
`;

export interface TenantsResult {
  brokerages: TenantRecord[];
}

export const TENANT_QUERY = gql`
  query Tenant($id: UUID!) {
    brokerage(id: $id) {
      ${TENANT_FIELDS}
    }
  }
`;

export interface TenantResult {
  brokerage: TenantRecord;
}

export const ORGANIZATIONS_QUERY = gql`
  query Organizations {
    organizations {
      ${ORGANIZATION_FIELDS}
    }
  }
`;

export interface OrganizationsResult {
  organizations: OrganizationRecord[];
}

export const ORGANIZATION_QUERY = gql`
  query Organization($id: UUID!) {
    organization(id: $id) {
      ${ORGANIZATION_FIELDS}
    }
  }
`;

export interface OrganizationResult {
  organization: OrganizationRecord;
}

export interface TenantInput {
  extAppApiId: string;
  name: string;
  slug?: string | null;
}

export const CREATE_TENANT = gql`
  mutation CreateTenant($input: TenantCreateInput!) {
    createTenant(input: $input) {
      ${TENANT_FIELDS}
    }
  }
`;

export interface CreateTenantResult {
  createTenant: TenantRecord;
}

export interface OrganizationInput {
  name: string;
  slug?: string | null;
  extAppApiId?: string | null;
}

export const CREATE_ORGANIZATION = gql`
  mutation CreateOrganization($input: OrganizationCreateInput!) {
    createOrganization(input: $input) {
      ${ORGANIZATION_FIELDS}
    }
  }
`;

export interface CreateOrganizationResult {
  createOrganization: OrganizationRecord;
}

export const SET_TENANT_ORGANIZATION = gql`
  mutation SetTenantOrganization($tenantId: UUID!, $organizationId: UUID) {
    setTenantOrganization(tenantId: $tenantId, organizationId: $organizationId) {
      ${TENANT_FIELDS}
    }
  }
`;

export interface SetTenantOrganizationResult {
  setTenantOrganization: TenantRecord;
}
